export interface MeetingNumberProps {
  value: number;
  className?: string;
}

export default function MeetingNumber({ value, className = '' }: MeetingNumberProps) {
  return (
    <span
      className={`font-unibet text-[24px] leading-[24px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark ${className}`}
    >
      {value}
    </span>
  );
}
